import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const isAuthenticated = !!localStorage.getItem("cvToken");
  const location = useLocation();

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={`${process.env.PUBLIC_URL}/login`}
      replace
      state={{ from: location }}
    />
  );
};

export default PrivateRoute;